<template>
  <div class="retail-hotel-views">
    <div class="list-view-option">
      <i class="fa fa-list-ul" /> List View
    </div>
    <div
      class="map-view-option"
      @click="displayMap"
    >
      <i class="fa fa-map-o" /> Map View
    </div>
    <div
      class="sort-filter-option"
      @click="toggleMobileFilter"
    >
      <i
        class="fa fa-sliders"
        aria-hidden="true"
      /> Sort/Filter
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  props: {
    contracted: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapMutations('hotel', ['showMap', 'setContractedOnlyMap', 'toggleFilter']),
    displayMap() {
      if (this.contracted) {
        this.setContractedOnlyMap(this.contracted)
      }
      this.showMap(true)
    },
    toggleMobileFilter(){
      this.$store.commit('toggleFilter')
      document.body.classList.toggle('end-state')
    }
  }
}
</script>
